module.exports = __webpack_public_path__ + "static/media/eng_d_2302.30af71a5.vtt";